import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { merchantThemes, device } from 'components/Variable'

export const FooterStyle = styled.footer`
	position: fixed;
	display: flex;
	flex-flow: row wrap;
	align-items: flex-end;
	z-index: 901;
	top: 100%;
	left: 0;
	right: 0;
	transform: translateY(0);
	opacity: 0;
	transition: transform 0.3s;
	border-top: ${rem(2)} solid ${({ theme }) => theme.color.blackOne};
	${(p) =>
		p.theme.name === merchantThemes.musto &&
		css`
			border-top: ${rem(2)} solid ${({ theme }) => theme.color.tertiary};
		`}

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border-top: ${rem(1)} solid ${({ theme }) => theme.color.primary};
		`}
	
	${(p) =>
		p.isVisible &&
		css`
			transform: translateY(-100%);
			opacity: 1;
		`}
`
export const Shadow = styled.div`
	position: absolute;
	left: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.4);
	transition: height 0.3s;
	z-index: 5;
	${(p) =>
		p.isOpen &&
		p.isVisible &&
		css`
			height: 100vh;
		`}
`
export const Text = styled.div`
	font-size: ${rem(16)};
	line-height: ${rem(24)};
	text-align: center;
	letter-spacing: ${rem(0.228571)};
	max-width: ${rem(300)};
	color: ${({ theme }) => theme.color.blackOne};
	margin: 0 auto;
	padding: 0 ${rem(3)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: 1.6;
		/*color: ${({ theme }) => theme.color.secondary};*/
	}

	@media (${device.mobileL}) {
		font-size: ${rem(11.5)};
		letter-spacing: ${rem(-0.228571)};
	}
`

export const Items = styled.div`
	padding: ${rem(0, 25)};
	max-height: 55vh;
	position: relative;
	overflow: auto;
	@media (${device.laptopS}) {
		padding: 0;
	}
`
export const List = styled.div`
	display: flex;
	flex-flow: row wrap;
	& > div {
		flex: 0 0 50%;
		max-width: 50%;
		padding: ${rem(0, 7)};
		margin-bottom: ${rem(14)};
	}
	@media (${device.laptopS}) {
		& > div {
			flex: 0 0 100%;
			max-width: 100%;
		}
	}
`
export const Title = styled.div`
	font-weight: 600;
	font-size: ${rem(20)};
	line-height: ${rem(25)};
	padding: ${rem(20, 0)};
	text-align: center;
	text-transform: uppercase;
	letter-spacing: ${rem(1.66667)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			text-transform: none;
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(15)};
		line-height: ${rem(20)};
		padding: ${rem(10, 0)};
	}
`
export const CartToggleButton = styled.div`
	position: absolute;
	z-index: 6;
	left: 50%;
	top: 0;
	margin: ${rem(0, 0, 0, -15)};
	padding: ${rem(3, 0, 0)};
	width: ${rem(30)};
	height: ${rem(30)};
	display: flex;
	justify-content: center;
	align-items: flex-start;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.color.blackOne};
	cursor: pointer;
	${(p) =>
		p.isVisible &&
		css`
			margin: ${rem(-14, 0, 0, -15)};
		`}
	${(p) =>
		p.theme.name === merchantThemes.musto &&
		css`
			background-color: ${({ theme }) => theme.color.tertiary};
		`}
	svg {
		fill: ${({ theme }) => theme.color.secondary};
		transform: rotate(-180deg);
		width: ${rem(10)};
		height: ${rem(10)};

		${(p) =>
			p.isOpen &&
			css`
				transform: rotate(0);
			`}
	}
`
export const Button = styled.button`
	font-size: ${rem(16)};
	line-height: ${rem(24)};
	letter-spacing: ${rem(0.228571)};
	cursor: pointer;
	background-color: transparent;
	min-width: ${rem(100)};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		/*color: ${({ theme }) => theme.color.secondary};*/
		font-size: ${rem(14)};
		line-height: ${rem(16)};
		letter-spacing: ${rem(-0.228571)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
				line-height: ${rem(20)};
				letter-spacing: ${rem(0.06)};
			`}
	}
	&:hover {
		text-decoration: underline;
	}
`
export const Total = styled.div`
	font-size: ${rem(18)};
	line-height: ${rem(28)};
	margin-bottom: ${rem(10)};
	letter-spacing: ${rem(0.257143)};
	text-align: center;
	width: 100%;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
			line-height: ${rem(20)};
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		line-height: ${rem(22)};
		letter-spacing: ${rem(-0.228571)};
		font-size: ${rem(13)};
		margin-bottom: 0;
	}
	& > div {
		padding: ${rem(5)};
		@media (${device.tablet}) {
			width: auto;
			padding: ${rem(0, 5)};
		}
	}
	span {
		font-weight: 600;
	}
	${(p) =>
		p.mode === 'row' &&
		css`
			display: flex;
			flex-flow: row wrap;
			justify-content: center;
		`}
`

export const PriceStrong = styled.span`
	font-weight: 600;
`
